// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.training-tab {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.training-tab-empty {
  align-items: center;
  justify-content: center;
}

.training-tab-empty-text {
  font-size: 28px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #575757;
}

.training-subtabs {
  display: flex;
  gap: 8px;
  padding-bottom: 12px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.18);
}

.training-subtabs button {
  padding: 8px 14px;
  border: none;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.08);
  cursor: pointer;
  font-size: 13px;
}

.training-subtabs button.active {
  background: #1f1f1f;
  color: white;
}

.training-subtab-content {
  flex: 1 1 auto;
  min-height: 0;
  padding-top: 12px;
}

.training-stage-tab {
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 0;
  border-radius: 10px;
  background:
    radial-gradient(circle at top, rgba(255, 255, 255, 0.75), rgba(240, 240, 240, 0.95)),
    linear-gradient(180deg, rgba(205, 225, 235, 0.4), rgba(240, 240, 240, 0.9));
  overflow: hidden;
}

.training-stage-canvas {
  width: 100%;
  height: 100%;
  display: block;
  cursor: default;
}

.training-stage-edge {
  stroke: #535353;
  stroke-width: 2;
}

.training-stage-node {
  cursor: grab;
  user-select: none;
}

.training-stage-node:active {
  cursor: grabbing;
}

.training-stage-node-label {
  fill: #171717;
  font-size: 11px;
  font-weight: 700;
  pointer-events: none;
}

.training-stage-hint {
  position: absolute;
  top: 12px;
  right: 14px;
  z-index: 1;
  padding: 6px 10px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  color: #4d4d4d;
  font-size: 12px;
}

.training-graph-toggle-button {
  position: absolute;
  left: 14px;
  bottom: 12px;
  z-index: 1;
  padding: 7px 11px;
  border: none;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.86);
  color: #2f2f2f;
  font-size: 12px;
  cursor: pointer;
  min-width: unset;
}

.training-stage-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #5a5a5a;
  font-size: 14px;
}

.training-object-tab {
  display: grid;
  grid-template-columns: 220px 1fr;
  gap: 16px;
  width: 100%;
  height: 100%;
  min-height: 0;
}

.training-object-list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-height: 0;
  overflow: auto;
  padding-right: 6px;
  border-right: 1px solid rgba(0, 0, 0, 0.12);
}

.training-object-list-item {
  padding: 8px 10px;
  border: none;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.05);
  color: #4b4b4b;
  text-align: left;
  cursor: pointer;
  font-size: 13px;
}

.training-object-list-item.selected {
  color: #0d5f90;
  background: rgba(85, 170, 215, 0.16);
  font-weight: 700;
}

.training-object-detail {
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 14px;
  min-width: 0;
  min-height: 0;
}

.training-object-info {
  display: grid;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.04);
}

.training-object-info-row {
  display: grid;
  grid-template-columns: 110px 1fr;
  gap: 12px;
  align-items: start;
  font-size: 13px;
}

.training-object-info-row span:first-child {
  color: #666666;
  font-weight: 700;
}

.training-object-info-row span:last-child {
  color: #1f1f1f;
  word-break: break-word;
}

.training-object-graph-panel {
  min-height: 0;
}

.training-object-edge-label {
  fill: #373737;
  font-size: 10px;
  font-weight: 700;
  pointer-events: none;
}

.training-object-edge-label-group {
  cursor: grab;
}

.training-object-edge-label-group:active {
  cursor: grabbing;
}

.training-object-edge-connector {
  stroke: #8a8a8a;
  stroke-width: 1;
}

.training-event-tab {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  gap: 8px;
}

.training-event-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.training-event-count {
  font-size: 12px;
  color: #777;
  flex-shrink: 0;
}

.training-event-filter {
  flex: 1 1 auto;
  padding: 4px 10px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 999px;
  font-size: 12px;
  background: rgba(0, 0, 0, 0.04);
  outline: none;
  min-width: 0;
}

.training-event-filter:focus {
  border-color: rgba(0, 0, 0, 0.3);
  background: white;
}

.training-event-print {
  position: absolute;
  bottom: -20px;
  right: -20px;
  padding: 0;
  width: 30px;
  height: 30px;
  min-width: unset;
  border: none;
  background: rgba(0, 0, 0, 0.08);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
  z-index: 1;
}

.training-event-print:hover {
  color: #333;
}

.training-event-clear {
  padding: 4px 10px;
  border: none;
  border-radius: 999px;
  background: rgba(0, 0, 0, 0.08);
  font-size: 12px;
  cursor: pointer;
  flex-shrink: 0;
}

.training-event-list {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  font-family: monospace;
  font-size: 11px;
}

.training-event-empty {
  color: #5a5a5a;
  font-size: 13px;
  font-family: inherit;
  padding: 8px 0;
}

.training-event-row {
  display: grid;
  grid-template-columns: 90px 225px 1fr auto;
  gap: 0 8px;
  padding: 2px 6px;
  border-radius: 4px;
  align-items: baseline;
}

.training-event-row:nth-child(odd) {
  background: rgba(0, 0, 0, 0.03);
}

.training-event-row.training-event-row-stage {
  background: rgba(90, 160, 255, 0.18);
}

.training-event-time {
  color: #888;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.training-event-type {
  color: #1a6baf;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.training-event-id {
  color: #1f1f1f;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.training-event-detail {
  color: #4a9a5f;
  white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/ui/components/debug-overlay/training-tab/TrainingTab.component.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,oBAAoB;EACpB,4CAA4C;AAC9C;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB;;+EAE6E;EAC7E,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,SAAS;EACT,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,oBAAoB;EACpB,eAAe;EACf,+BAA+B;EAC/B,aAAa;EACb,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB","sourcesContent":[".training-tab {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n}\n\n.training-tab-empty {\n  align-items: center;\n  justify-content: center;\n}\n\n.training-tab-empty-text {\n  font-size: 28px;\n  font-weight: 700;\n  letter-spacing: 0.08em;\n  color: #575757;\n}\n\n.training-subtabs {\n  display: flex;\n  gap: 8px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.18);\n}\n\n.training-subtabs button {\n  padding: 8px 14px;\n  border: none;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.08);\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.training-subtabs button.active {\n  background: #1f1f1f;\n  color: white;\n}\n\n.training-subtab-content {\n  flex: 1 1 auto;\n  min-height: 0;\n  padding-top: 12px;\n}\n\n.training-stage-tab {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  border-radius: 10px;\n  background:\n    radial-gradient(circle at top, rgba(255, 255, 255, 0.75), rgba(240, 240, 240, 0.95)),\n    linear-gradient(180deg, rgba(205, 225, 235, 0.4), rgba(240, 240, 240, 0.9));\n  overflow: hidden;\n}\n\n.training-stage-canvas {\n  width: 100%;\n  height: 100%;\n  display: block;\n  cursor: default;\n}\n\n.training-stage-edge {\n  stroke: #535353;\n  stroke-width: 2;\n}\n\n.training-stage-node {\n  cursor: grab;\n  user-select: none;\n}\n\n.training-stage-node:active {\n  cursor: grabbing;\n}\n\n.training-stage-node-label {\n  fill: #171717;\n  font-size: 11px;\n  font-weight: 700;\n  pointer-events: none;\n}\n\n.training-stage-hint {\n  position: absolute;\n  top: 12px;\n  right: 14px;\n  z-index: 1;\n  padding: 6px 10px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.78);\n  color: #4d4d4d;\n  font-size: 12px;\n}\n\n.training-graph-toggle-button {\n  position: absolute;\n  left: 14px;\n  bottom: 12px;\n  z-index: 1;\n  padding: 7px 11px;\n  border: none;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.86);\n  color: #2f2f2f;\n  font-size: 12px;\n  cursor: pointer;\n  min-width: unset;\n}\n\n.training-stage-empty {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  color: #5a5a5a;\n  font-size: 14px;\n}\n\n.training-object-tab {\n  display: grid;\n  grid-template-columns: 220px 1fr;\n  gap: 16px;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n}\n\n.training-object-list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  min-height: 0;\n  overflow: auto;\n  padding-right: 6px;\n  border-right: 1px solid rgba(0, 0, 0, 0.12);\n}\n\n.training-object-list-item {\n  padding: 8px 10px;\n  border: none;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.05);\n  color: #4b4b4b;\n  text-align: left;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.training-object-list-item.selected {\n  color: #0d5f90;\n  background: rgba(85, 170, 215, 0.16);\n  font-weight: 700;\n}\n\n.training-object-detail {\n  display: grid;\n  grid-template-rows: auto 1fr;\n  gap: 14px;\n  min-width: 0;\n  min-height: 0;\n}\n\n.training-object-info {\n  display: grid;\n  gap: 8px;\n  padding: 12px 14px;\n  border-radius: 10px;\n  background: rgba(0, 0, 0, 0.04);\n}\n\n.training-object-info-row {\n  display: grid;\n  grid-template-columns: 110px 1fr;\n  gap: 12px;\n  align-items: start;\n  font-size: 13px;\n}\n\n.training-object-info-row span:first-child {\n  color: #666666;\n  font-weight: 700;\n}\n\n.training-object-info-row span:last-child {\n  color: #1f1f1f;\n  word-break: break-word;\n}\n\n.training-object-graph-panel {\n  min-height: 0;\n}\n\n.training-object-edge-label {\n  fill: #373737;\n  font-size: 10px;\n  font-weight: 700;\n  pointer-events: none;\n}\n\n.training-object-edge-label-group {\n  cursor: grab;\n}\n\n.training-object-edge-label-group:active {\n  cursor: grabbing;\n}\n\n.training-object-edge-connector {\n  stroke: #8a8a8a;\n  stroke-width: 1;\n}\n\n.training-event-tab {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  gap: 8px;\n}\n\n.training-event-controls {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-shrink: 0;\n}\n\n.training-event-count {\n  font-size: 12px;\n  color: #777;\n  flex-shrink: 0;\n}\n\n.training-event-filter {\n  flex: 1 1 auto;\n  padding: 4px 10px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 999px;\n  font-size: 12px;\n  background: rgba(0, 0, 0, 0.04);\n  outline: none;\n  min-width: 0;\n}\n\n.training-event-filter:focus {\n  border-color: rgba(0, 0, 0, 0.3);\n  background: white;\n}\n\n.training-event-print {\n  position: absolute;\n  bottom: -20px;\n  right: -20px;\n  padding: 0;\n  width: 30px;\n  height: 30px;\n  min-width: unset;\n  border: none;\n  background: rgba(0, 0, 0, 0.08);\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #999;\n  z-index: 1;\n}\n\n.training-event-print:hover {\n  color: #333;\n}\n\n.training-event-clear {\n  padding: 4px 10px;\n  border: none;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, 0.08);\n  font-size: 12px;\n  cursor: pointer;\n  flex-shrink: 0;\n}\n\n.training-event-list {\n  flex: 1 1 auto;\n  min-height: 0;\n  overflow-y: auto;\n  font-family: monospace;\n  font-size: 11px;\n}\n\n.training-event-empty {\n  color: #5a5a5a;\n  font-size: 13px;\n  font-family: inherit;\n  padding: 8px 0;\n}\n\n.training-event-row {\n  display: grid;\n  grid-template-columns: 90px 225px 1fr auto;\n  gap: 0 8px;\n  padding: 2px 6px;\n  border-radius: 4px;\n  align-items: baseline;\n}\n\n.training-event-row:nth-child(odd) {\n  background: rgba(0, 0, 0, 0.03);\n}\n\n.training-event-row.training-event-row-stage {\n  background: rgba(90, 160, 255, 0.18);\n}\n\n.training-event-time {\n  color: #888;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.training-event-type {\n  color: #1a6baf;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.training-event-id {\n  color: #1f1f1f;\n  font-weight: 600;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.training-event-detail {\n  color: #4a9a5f;\n  white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
